import { HYPERFLOW_CREDENTIALS_LOADED, HYPERFLOW_ACCESS_CHANGED } from '../actions/actionTypes';

export interface IHyperflowState {
  credentialsLoaded: boolean;
  currentAccess: string | null;
  lastAccessCheck: string | null;
}

const initialState: IHyperflowState = {
  credentialsLoaded: false,
  currentAccess: null,
  lastAccessCheck: null,
};

const hyperflowReducer = (state = initialState, action: any): IHyperflowState => {
  switch (action.type) {
    case HYPERFLOW_CREDENTIALS_LOADED:
      return {
        ...state,
        credentialsLoaded: true,
        lastAccessCheck: action.payload.access,
      };
    
    case HYPERFLOW_ACCESS_CHANGED:
      return {
        ...state,
        credentialsLoaded: false, // Reset quando o access muda
        currentAccess: action.payload.access,
      };
    
    default:
      return state;
  }
};

export default hyperflowReducer;
